import { render, staticRenderFns } from "./NutritionTemplate.vue?vue&type=template&id=399d867e&scoped=true"
import script from "./NutritionTemplate.vue?vue&type=script&lang=js"
export * from "./NutritionTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399d867e",
  null
  
)

export default component.exports